module.exports = require("readline/promises");